var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYinYang = function SvgIconYinYang(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13.5 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12m2 0a8 8 0 0 1 8-8 3.5 3.5 0 1 1 0 7 5.5 5.5 0 0 0-5.291 7A7.98 7.98 0 0 1 4 12m13.5-4.5c0-.512-.071-1.016-.209-1.5A8 8 0 0 1 12 20a3.5 3.5 0 1 1 0-7 5.5 5.5 0 0 0 5.5-5.5",
    clipRule: "evenodd"
  }))));
};
export default SvgIconYinYang;